'use client';

import { Carousel, CarouselContent, CarouselDots, CarouselItem } from '@/components/ui/Carousel';
import StatefulLink from '@/components/StatefulLink';
import { dynamicClientRouteMaker } from '@/helpers/routes/dynamicClientRouteMaker';
import useSourcePageTracker from '@/context/sourcePageTracker/useSourcePageTracker';
import DorsaImage from '@/components/dorsaImage/DorsaImage';
import { IMAGE_SHAPES, IMAGE_SIZES } from '@/components/dorsaImage/imageTypes';
import ContentCardBadges from '@/app/community/components/ContentCardBadges';
import Autoplay from 'embla-carousel-autoplay';
import { useLayoutEffect, useRef, useState } from 'react';
import { cn } from '@/helpers/cn';
import useAuth from '@/context/auth/useAuth';

export default function ImageSlider({ data }) {
    const { sourcePageData } = useSourcePageTracker();
    const { userIsLoggedIn, setInAppLoginModalIsOpen } = useAuth();
    const plugin = useRef(Autoplay({ delay: 3000, stopOnInteraction: false }));
    const [show, setShow] = useState(false);

    useLayoutEffect(() => {
        setShow(true);
    }, []);

    return (
        <div
            className={cn(
                'w-full max-w-[450px] mx-auto transition-all',
                show ? 'opacity-100' : 'opacity-0'
            )}>
            <Carousel
                opts={{
                    align: 'center',
                    loop: true,
                    direction: 'rtl'
                }}
                plugins={[plugin.current]}
                className="w-full">
                <CarouselContent className="py-8">
                    {data.cards.map((card, index) => {
                        const { is_exclusive, is_coming_soon } = card.media_object || {};

                        return (
                            <CarouselItem className="basis-[66%]" key={index}>
                                <StatefulLink
                                    href={dynamicClientRouteMaker({
                                        id: card?.related_link?.obj_id,
                                        type: card?.related_link?.obj_type,
                                        url: card?.related_link?.url,
                                        urlAlias: card?.related_link?.url_alias
                                    })}
                                    state={sourcePageData}
                                    onClick={(event) => {
                                        if (
                                            !userIsLoggedIn &&
                                            card?.related_link?.obj_type === 'FakeMatch'
                                        ) {
                                            event.preventDefault();
                                            setInAppLoginModalIsOpen({
                                                isOpen: true,
                                                previousUrl: location.pathname
                                            });
                                        }
                                    }}
                                    className="relative block overflow-hidden rounded-2xl shadow-[0px_3px_28px_0px_#0000000d]">
                                    <DorsaImage
                                        config={{
                                            shape: IMAGE_SHAPES.VERTICAL,
                                            size: IMAGE_SIZES.SIZE_3
                                        }}
                                        src={card?.media_object?.posters?.vertical_poster}
                                        className="h-full w-full aspect-[0.67]"
                                        id={card?.related_link?.obj_id}
                                        alt={card?.media_object?.posters?.alt_text}
                                        loading="eager"
                                    />
                                    <ContentCardBadges
                                        isExclusive={is_exclusive}
                                        isComingSoon={is_coming_soon}
                                        size="vertical-large"
                                    />
                                </StatefulLink>
                            </CarouselItem>
                        );
                    })}
                </CarouselContent>
                <CarouselDots
                    className="max-w-[450px] bottom-14 left-1/2 -translate-x-1/2 absolute z-[3] flex items-center justify-center gap-2 bg-[#f5f6f833] rounded-[36px] px-2.5 py-2"
                    dotsClassName="h-1.5 w-1.5 aspect-square rounded-full bg-[#747572]"
                    activeDotsClassName="bg-white"
                />
            </Carousel>
        </div>
    );
}
